import { useCreateHeyLightAdminAxiosInstance } from "../../Auth/useCreateHeyLightAdminAxiosInstance.ts";
import { useState } from "react";

export function useRefundHeyLightOrder() {
  const { createAxiosInstance } = useCreateHeyLightAdminAxiosInstance();

  const [loading, setLoading] = useState(false);
  const refundHeyLightOrder = async (
    orderId: string,
    partialAmountInCents?: number,
  ): Promise<void> => {
    const axiosInstance = createAxiosInstance();
    try {
      setLoading(true);
      await axiosInstance.post(`/admin/orders/${orderId}/refund`, {
        orderId,
        ...(partialAmountInCents && {
          amountToRefundInCents: {
            amount: partialAmountInCents,
            currency: "EUR",
          },
        }),
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    refundHeyLightOrder,
    loading,
  };
}
